import { z } from 'zod';
import { dateStringValidation } from './dateString.js';
export const budgetLineSchema = z.object({
    label: z.string(),
    section: z.string(),
    variancePct: z.number(),
});
export const cashPositionSchema = z.object({
    totalCash: z.number(),
    operatingCash: z.number(),
    reserveCash: z.number(),
    operatingRunwayMonths: z.number().optional(),
});
export const budgetPerformanceSchema = z.object({
    totalVarianceAmount: z.number(),
    totalVariancePct: z.number(),
    topOverBudget: z.array(budgetLineSchema).default([]),
    topUnderBudget: z.array(budgetLineSchema).default([]),
});
export const receivablesPayablesRiskSchema = z.object({
    arTotal: z.number(),
    delinquencyPct: z.number(),
    arDays1to30: z.number(),
    arDays31to60: z.number(),
    arDays61to90: z.number(),
    arDays90Plus: z.number(),
    apTotal: z.number(),
    apDays1to30: z.number(),
    apDays31to60: z.number(),
    apDays61to90: z.number(),
    apDays90Plus: z.number(),
    apOverdue: z.number(),
    netCashPressureSummary: z.string(),
});
export const reserveHealthSchema = z.object({
    reserveBalance: z.number(),
    plannedCapitalSpend: z.number().optional(),
    coveragePct: z.number().optional(),
});
export const financialHealthStatusSchema = z.enum(['healthy', 'watch', 'at-risk']);
export const apAgingSourceSchema = z.enum(['teo', 'qbo']);
export const financialSummaryApAgingSchema = z.object({
    current: z.number(),
    days31to60: z.number(),
    days61to90: z.number(),
    days90Plus: z.number(),
    totalAP: z.number(),
    overdueAP: z.number(),
});
export const financialHealthSummarySchema = z.object({
    overallStatus: financialHealthStatusSchema,
    statusExplanation: z.string(),
    keyInsights: z.array(z.string()),
    risksAndAlerts: z.array(z.string()),
    suggestedActions: z.array(z.string()),
    cashPosition: cashPositionSchema,
    budgetPerformance: budgetPerformanceSchema.optional(),
    receivablesPayablesRisk: receivablesPayablesRiskSchema,
    reserveHealth: reserveHealthSchema,
    netCashImpact: z.string(),
    generatedAt: z.coerce.date().optional(),
    apAgingSource: apAgingSourceSchema.optional(),
    asOfDate: dateStringValidation.optional(),
    apAgingSnapshot: financialSummaryApAgingSchema.optional(),
    qboApAging: financialSummaryApAgingSchema.optional(),
});
export const resilientFinancialHealthSummarySchema = financialHealthSummarySchema
    .omit({
    generatedAt: true,
    apAgingSource: true,
    asOfDate: true,
    apAgingSnapshot: true,
    qboApAging: true,
})
    .extend({
    receivablesPayablesRisk: receivablesPayablesRiskSchema.partial({
        apTotal: true,
        apOverdue: true,
        apDays1to30: true,
        apDays31to60: true,
        apDays61to90: true,
        apDays90Plus: true,
        arDays1to30: true,
        arDays31to60: true,
        arDays61to90: true,
        arDays90Plus: true,
    }),
});
export const financialQuestionAnswerSchema = z.object({
    answer: z.string(),
    citations: z.array(z.string()),
});
//# sourceMappingURL=financialSummary.js.map